import { render, staticRenderFns } from "./ListCart.vue?vue&type=template&id=2a034b4f&scoped=true&"
import script from "./ListCart.vue?vue&type=script&lang=ts&"
export * from "./ListCart.vue?vue&type=script&lang=ts&"
import style0 from "./ListCart.vue?vue&type=style&index=0&id=2a034b4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a034b4f",
  null
  
)

export default component.exports